import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { IServiceOrdersByTagReportFilters } from "./Filters";
import { useLanguageContext } from "../../../../../contexts/LanguageContext";
import { ServicePriorityData, ServiceStatusData } from "../../../../../data/Enums";
import { useEffect, useMemo } from "react";
import FormHelper from "../../../../../helpers/FormHelper";
import { HomeRepairService, LocalOffer } from "@mui/icons-material";
import DefaultConstants from "../../../../../data/Constants";
import useState from "../../../../../hooks/useState";
import DateTimeHelper from "../../../../../helpers/DateTimeHelper";
import ServiceOrderTagService from "../../../../../services/ServiceOrderTagService";
import IServiceOrdersByTag from "../../../../../interfaces/IServiceOrderTag";
import Chip from "../../../../../components/Chip";
import ColorHelper from "../../../../../helpers/ColorHelper";


interface IStateValues {
    tags: IServiceOrdersByTag[];
}

const ServiceOrdersByTagContent: React.FunctionComponent<IServiceOrdersByTagReportFilters> = (filters) => {
    const { translate } = useLanguageContext();

    const state = useState<IStateValues>({
        tags: []
    });


    useEffect(() => {
        let formData = FormHelper.Create(undefined);
        
        Object.entries(filters).forEach(([key, value]) => {
            if (key === 'enterprise') {
                key = 'enterpriseId';
                value = value.id;
            } else if (key === 'status' || key === 'priority') {
                value = value.join(',');
            } else if (key === 'department' || key === 'responsible' || key === 'room') {
                value = value.map((r: any) => r.id).join(',');
            }

            formData = FormHelper.Add(formData, key, value);
        });

        ServiceOrderTagService.GetTotalizers(formData).then(resp => {
            state.update('tags', resp.data.tags as IServiceOrdersByTag[]);
        }).catch(err => {
            state.update('tags', []);
        })
        // eslint-disable-next-line
    }, []);


    const renderFilterFieldset = useMemo(() => {
        return <TableCell className='reportpreview-paper-content-fieldset'>
                <Typography variant='caption' className='reportpreview-paper-content-fieldset-label'>
                    {translate('filters')}
                </Typography>

                <Grid container>
                    <Grid xs={3} className='reportpreview-paper-content-fieldset-item'>
                        <Typography variant='subtitle1' className='reportpreview-paper-content-fieldset-item-title'>
                            {translate('startDate')}
                        </Typography>

                        <Typography variant='body1' className='reportpreview-paper-content-fieldset-item-value'>
                            {DateTimeHelper.Format(filters.startDate, 'DD/MM/YYYY')}
                        </Typography>
                    </Grid>

                    <Grid xs={3} className='reportpreview-paper-content-fieldset-item'>
                        <Typography variant='subtitle1' className='reportpreview-paper-content-fieldset-item-title'>
                            {translate('endDate')}
                        </Typography>

                        <Typography variant='body1' className='reportpreview-paper-content-fieldset-item-value'>
                            {DateTimeHelper.Format(filters.endDate, 'DD/MM/YYYY')}
                        </Typography>
                    </Grid>

                    <Grid xs={3} className='reportpreview-paper-content-fieldset-item'>
                        <Typography variant='subtitle1' className='reportpreview-paper-content-fieldset-item-title'>
                            {translate('serviceStatus')}
                        </Typography>

                        <Typography variant='body1' className='reportpreview-paper-content-fieldset-item-value'>
                            {
                                filters.status.length === 0 ? (
                                    translate('all')
                                ) : (
                                    Object.values(ServiceStatusData)
                                        .filter(s => filters.status.includes(s.key))
                                        .map(s => translate(s.name))
                                        .join(', ')
                                )
                            }
                        </Typography>
                    </Grid>

                    <Grid xs={3} className='reportpreview-paper-content-fieldset-item'>
                        <Typography variant='subtitle1' className='reportpreview-paper-content-fieldset-item-title'>
                            {translate('priority')}
                        </Typography>

                        <Typography variant='body1' className='reportpreview-paper-content-fieldset-item-value'>
                            {
                                filters.priority.length === 0 ? (
                                    translate('all')
                                ) : (
                                    Object.values(ServicePriorityData)
                                        .filter(s => filters.priority.includes(s.key))
                                        .map(s => translate(s.name))
                                        .join(', ')
                                )
                            }
                        </Typography>
                    </Grid>

                    <Grid xs={3} className='reportpreview-paper-content-fieldset-item'>
                        <Typography variant='subtitle1' className='reportpreview-paper-content-fieldset-item-title'>
                            {translate('room')}
                        </Typography>

                        <Typography variant='body1' className='reportpreview-paper-content-fieldset-item-value'>
                            {
                                filters.room.length === 0 ? (
                                    translate('all')
                                ) : (
                                    filters.room.map(r => r.description).join(', ')
                                )
                            }
                        </Typography>
                    </Grid>

                    <Grid xs={3} className='reportpreview-paper-content-fieldset-item'>
                        <Typography variant='subtitle1' className='reportpreview-paper-content-fieldset-item-title'>
                            {translate('department')}
                        </Typography>

                        <Typography variant='body1' className='reportpreview-paper-content-fieldset-item-value'>
                            {
                                filters.department.length === 0 ? (
                                    translate('all')
                                ) : (
                                    filters.department.map(d => d.name).join(', ')
                                )
                            }
                        </Typography>
                    </Grid>

                    <Grid xs={3} className='reportpreview-paper-content-fieldset-item'>
                        <Typography variant='subtitle1' className='reportpreview-paper-content-fieldset-item-title'>
                            {translate('responsible')}
                        </Typography>

                        <Typography variant='body1' className='reportpreview-paper-content-fieldset-item-value'>
                            {
                                filters.responsible.length === 0 ? (
                                    translate('all')
                                ) : (
                                    filters.responsible.map(r => r.fullName).join(', ')
                                )
                            }
                        </Typography>
                    </Grid>

                    <Grid xs={3} className='reportpreview-paper-content-fieldset-item'>
                        <Typography variant='subtitle1' className='reportpreview-paper-content-fieldset-item-title'>
                            {translate('_hideZeroedTags')}
                        </Typography>

                        <Typography variant='body1' className='reportpreview-paper-content-fieldset-item-value'>
                            {translate(filters.hideZeroedTags ? 'yes' : 'no')}
                        </Typography>
                    </Grid>
                </Grid>
            </TableCell>;
    }, [filters, translate]);


    const data = useMemo(() => {
        return state.values.tags;
        // eslint-disable-next-line
    }, [state.values.tags, filters]);
    
    
    return <>
        <TableRow>
            {renderFilterFieldset}
        </TableRow>

        <TableRow>
            <TableCell className='border-none' padding='none'>
                {
                    data.length > 0 ? (
                        <>
                            <Table className='data-table' sx={{ marginY: DefaultConstants.gridRowSpacing }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{translate('tag')}</TableCell>
                                        <TableCell>{translate('serviceOrders')}</TableCell>
                                        <TableCell>{translate('byStatus')}</TableCell>
                                        <TableCell>{translate('byPriority')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                
                                <TableBody className='tbody-striped'>
                                    {
                                        data.map(row => {
                                            return <TableRow key={row.id}>
                                                <TableCell>
                                                    <Typography className='text-title'>
                                                        <Chip label={row.name} size='small' />
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography className='text-title'>
                                                        <HomeRepairService />
                                                        {row.serviceOrders.length ?? 0}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Box className='display-flex alignitems-center justifycontent-flexstart gap-4'>
                                                        {
                                                            Object.values(ServiceStatusData).map((s, index) => {
                                                                const backgroundColor = ColorHelper.ApplyOpacityToHex(s.color, 0.2);

                                                                return <Typography
                                                                    className='text-title borderradius-default' 
                                                                    key={index}
                                                                    padding={0.2}
                                                                    paddingRight={0.6}
                                                                    sx={{
                                                                        color: `${s.color} !important`,
                                                                        backgroundColor: `${backgroundColor} !important`
                                                                    }}
                                                                >
                                                                    <s.Icon />
                                                                    {row.serviceOrders.filter(so => +(so.statusId ?? 0) === s.key).length ?? 0}
                                                                </Typography>;
                                                            })
                                                        }
                                                    </Box>
                                                </TableCell>

                                                <TableCell>
                                                    <Box className='display-flex alignitems-center justifycontent-flexstart gap-4'>
                                                        {
                                                            Object.values(ServicePriorityData).map((p, index) => {
                                                                const backgroundColor = ColorHelper.ApplyOpacityToHex(p.color, 0.2);

                                                                return <Typography
                                                                    className='text-title borderradius-default' 
                                                                    key={index}
                                                                    padding={0.2}
                                                                    paddingRight={0.6}
                                                                    sx={{
                                                                        color: `${p.color} !important`,
                                                                        backgroundColor: `${backgroundColor} !important`
                                                                    }}
                                                                >
                                                                    <p.Icon />
                                                                    {row.serviceOrders.filter(so => +(so.priorityId ?? 0) === p.key).length ?? 0}
                                                                </Typography>;
                                                            })
                                                        }
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </>
                    ) : (
                        <Box className='reportpreview-paper-content-notfound' marginBottom={DefaultConstants.gridRowSpacing}>
                            <Typography variant='body1'>{translate('_serviceOrdersByTagEmptyList')}</Typography>
                        </Box>
                    )
                }

                {/* Summary */}
                <Table className='page-break show-only-in-print'>
                    {renderFilterFieldset}
                </Table>

                <Table className='data-table' sx={{ marginTop: DefaultConstants.gridRowSpacing }}>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={3}>{translate('summary')}</TableCell>
                        </TableRow>
                    </TableHead>
                    
                    <TableBody className='tbody-striped'>
                        <TableRow>
                            <TableCell className='color-primary display-flex alignitems-center fontweight-600 gap-10'>
                                <LocalOffer className='fontsize-20' />
                                {translate('tags')}
                            </TableCell>
                            <TableCell className='textalign-right fontweight-600'>{data.length}</TableCell>
                            <TableCell className='textalign-right fontweight-600' width={80}>100.0 %</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

                <Table className='data-table' sx={{ marginTop: DefaultConstants.gridRowSpacing }}>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={3}>{translate('byStatus')}</TableCell>
                        </TableRow>
                    </TableHead>
                    
                    <TableBody className='tbody-striped'>
                        {
                            Object.values(ServiceStatusData).map(s => {
                                const value = data.reduce((acc, curr) => {
                                    return acc + (curr.serviceOrders.some(so => +(so.statusId ?? 0) === s.key) ? 1 : 0);
                                }, 0);
                                const percentage = data.length === 0 ? 0 : value / data.length * 100;

                                return <TableRow>
                                    <TableCell 
                                        className='display-flex alignitems-center fontweight-600 gap-10'
                                        sx={{
                                            color: `${s.color} !important`
                                        }}
                                    >
                                        <s.Icon className='fontsize-20' />
                                        {translate(s.name)}
                                    </TableCell>
                                    <TableCell className='textalign-right fontweight-600'>{value}</TableCell>
                                    <TableCell className='textalign-right fontweight-600' width={80}>{percentage.toFixed(1)} %</TableCell>
                                </TableRow>;
                            })
                        }
                    </TableBody>
                </Table>

                <Table className='data-table' sx={{ marginTop: DefaultConstants.gridRowSpacing }}>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={3}>{translate('priority')}</TableCell>
                        </TableRow>
                    </TableHead>
                    
                    <TableBody className='tbody-striped'>
                        {
                            Object.values(ServicePriorityData).map(p => {
                                const value = data.reduce((acc, curr) => {
                                    return acc + (curr.serviceOrders.some(so => +(so.priorityId ?? 0) === p.key) ? 1 : 0);
                                }, 0);
                                const percentage = data.length === 0 ? 0 : value / data.length * 100;

                                return <TableRow>
                                    <TableCell 
                                        className='display-flex alignitems-center fontweight-600 gap-10'
                                        sx={{
                                            color: `${p.color} !important`
                                        }}
                                    >
                                        <p.Icon className='fontsize-20' />
                                        {translate(p.name)}
                                    </TableCell>
                                    <TableCell className='textalign-right fontweight-600'>{value}</TableCell>
                                    <TableCell className='textalign-right fontweight-600' width={80}>{percentage.toFixed(1)} %</TableCell>
                                </TableRow>;
                            })
                        }
                    </TableBody>
                </Table>
            </TableCell>
        </TableRow>
    </>;
}

export default ServiceOrdersByTagContent;